export const space = {
    space05: "2px",
    space10: "4px",
    space20: "8px",
    space30: "12px",
    space40: "16px",
    space45: "20px",
    space50: "24px",
    space55: "28px",
    space60: "32px",
    space65: "40px",
    space70: "48px",
} as const;
